var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tva-highlight-component tva-row"},[_c('div',{staticClass:"highlight tva-col-xs-offset-1 tva-col-xs-10 tva-col-md-offset-4 tva-col-md-7"},[_c('h5',[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }